// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import BundleRunningAvailability from './bundle-running-availability';
import React from 'react';

function BundleRunningAvailabilityPage () {

    return (
        <AuthenticatedPage className="atp-page atp-bundle-running-availability-page">
            <BundleRunningAvailability />
        </AuthenticatedPage>
    );

}
BundleRunningAvailabilityPage.displayNAme = 'BundleRunningAvailabilityPage';

export default BundleRunningAvailabilityPage;
